const PAY_BASE = 'https://pay.urotunings.com';

(function () {
  function getShopName(btn) {
    return (
      btn.dataset.shopName ||
      (window.Shopify && window.Shopify.shop) ||
      window.location.hostname
    );
  }

  function getShopDomain(btn) {
    return btn.dataset.shopDomain || window.location.hostname;
  }

  function getMyshopifyDomain(btn) {
    return (
      btn.dataset.shopMyshopifyDomain ||
      (window.Shopify && window.Shopify.shop) ||
      window.location.hostname
    );
  }

  function getCurrency(cart) {
    return (
      (cart && cart.currency) ||
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      'USD'
    );
  }

  function getPayBase(btn) {
    return btn.dataset.payUrl || PAY_BASE;
  }

  function redirectToPay(payBase, payload) {
    const finalUrl =
      payBase.replace(/\/$/, '') +
      '/checkout.html?payload=' +
      encodeURIComponent(JSON.stringify(payload));

    console.log('PAY PAYLOAD:', payload);
    console.log('PAY FINAL URL:', finalUrl);

    window.location.href = finalUrl;
  }

  document.addEventListener(
    'click',
    async function (e) {
      const btn = e.target.closest(
        '.custom-buy-now, .custom-cart-checkout, #CartDrawer-Checkout, #checkout'
      );

      if (!btn) return;
      if (btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();

      const oldText = btn.innerText;

      try {
        btn.disabled = true;
        btn.innerText = 'Loading...';

        const payBase = getPayBase(btn);
        const shopName = getShopName(btn);
        const shopDomain = getShopDomain(btn);
        const myshopifyDomain = getMyshopifyDomain(btn);

        // 商品页 BUY IT NOW：不再调用 cart/add.js，避免 Shopify 验证页拦截
        if (btn.classList.contains('custom-buy-now')) {
          const productForm =
            btn.closest('form') ||
            document.querySelector('form[action*="/cart/add"]');

          if (!productForm) {
            throw new Error('Product form not found');
          }

          const variantInput =
            productForm.querySelector('.product-variant-id') ||
            productForm.querySelector('[name="id"]');

          if (!variantInput || !variantInput.value) {
            throw new Error('Variant ID not found');
          }

          const quantityInput = productForm.querySelector('[name="quantity"]');
          const variantId = Number(variantInput.value);
          const quantity = quantityInput
            ? Math.max(1, parseInt(quantityInput.value || '1', 10))
            : 1;

const productComponent = btn.closest('product-form-component');

const productPath =
  (productComponent && productComponent.dataset.productUrl) ||
  window.location.pathname;

const productJsonUrl =
  productPath.replace(/\/$/, '') + '.js';
  
          const productRes = await fetch(productJsonUrl, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json'
            }
          });

          if (!productRes.ok) {
            throw new Error('product .js failed');
          }

          const product = await productRes.json();

          const variant =
            (product.variants || []).find(function (v) {
              return Number(v.id) === variantId;
            }) ||
            (product.variants || [])[0] ||
            {};

          const priceCents = Number(variant.price || product.price || 0);
          const price = priceCents / 100;
          const image =
            product.featured_image ||
            (Array.isArray(product.images) && product.images.length
              ? product.images[0]
              : '');

          const payload = {
            storeName: shopName,
            store_name: shopName,
            shop_name: shopName,
            shop_domain: shopDomain,
            shop_myshopify_domain: myshopifyDomain,
            cart_token: '',
            currency: getCurrency(null),
            item_count: quantity,
            subtotal_price: price * quantity,
            total_price: price * quantity,
            shippingPrice: 0,
            items: [
              {
                title: product.title || 'Product',
                variant: variant.title || 'Default Title',
                quantity: quantity,
                price: price,
                image: image,
                line_key: '',
                variant_id: variantId,
                product_id: product.id || '',
                product_title: product.title || '',
                variant_title: variant.title || '',
                line_price: price * quantity,
                sku: variant.sku || '',
                vendor: product.vendor || ''
              }
            ]
          };

          redirectToPay(payBase, payload);
          return;
        }

        // 购物车页 / 抽屉购物车：只读取 cart.js，不调用 cart/add.js
        const root =
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';

        const cartRes = await fetch(root + 'cart.js', {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        });

        if (!cartRes.ok) {
          const cartText = await cartRes.text();
          throw new Error('cart.js failed: ' + cartText.slice(0, 300));
        }

        const cart = await cartRes.json();

        if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
          throw new Error('Cart is empty');
        }

        const payload = {
          storeName: shopName,
          store_name: shopName,
          shop_name: shopName,
          shop_domain: shopDomain,
          shop_myshopify_domain: myshopifyDomain,
          cart_token: cart.token || '',
          currency: getCurrency(cart),
          item_count: cart.item_count || 0,
          subtotal_price: (cart.items_subtotal_price || 0) / 100,
          total_price: (cart.total_price || 0) / 100,
          shippingPrice: 0,
          items: (cart.items || []).map(function (item) {
            return {
              title: item.product_title || item.title || 'Product',
              variant: item.variant_title || 'Default Title',
              quantity: item.quantity || 1,
              price: (item.price || 0) / 100,
              image: item.image || '',
              line_key: item.key || '',
              variant_id: item.id || '',
              product_id: item.product_id || '',
              product_title: item.product_title || item.title || '',
              variant_title: item.variant_title || '',
              line_price: (item.line_price || 0) / 100,
              sku: item.sku || '',
              vendor: item.vendor || ''
            };
          })
        };

        redirectToPay(payBase, payload);
      } catch (err) {
        console.error('PAY DEBUG:', err);

        alert(
          '读取 Shopify 订单信息失败：' +
            (err && err.message ? err.message : String(err))
        );

        btn.disabled = false;
        btn.innerText = oldText;
      }
    },
    true
  );
})();